export default __webpack_public_path__ + "static/media/1455.3170fc98.png";